import axios from "axios";
import { normalizeSnapshot, normalizePauses } from "../utils/pausenplanSnapshot";

export function createPausenplanApi(http = axios) {
  async function load(auth, registerAbort) {
    // Axios 0.19 uses CancelToken; do not require a newer browser/client API.
    const source = axios.CancelToken.source();
    registerAbort(() => source.cancel("Pausenplan context disposed"));
    const params = auth.id && auth.token
      ? { id: auth.id, token: auth.token }
      : { publicId: auth.publicId, publicToken: auth.publicToken };
    const get = async (name, extra = {}) => {
      const response = await http.get("/api/pausenplan/" + name, {
        params: { ...params, ...extra }, timeout: 15000, cancelToken: source.token
      });
      const body = response.data;
      if (!body || String(body.type).toUpperCase() !== "SUCCESS" || !Object.prototype.hasOwnProperty.call(body, "data")) {
        throw new Error("Invalid Pausenplan response: " + name);
      }
      return body.data;
    };
    try {
      const [options, positions, employees, rotas, external, shifts] = await Promise.all(
        ["options", "positions", "employees", "rotas", "external", "shifts"].map(name => get(name))
      );
      const snapshot = normalizeSnapshot({ options, positions, employees, rotas, external, shifts });
      snapshot.pauses = snapshot.shifts.length
        ? normalizePauses(await get("pauses", { shiftIds: snapshot.shifts.map(shift => shift.id).join(",") }))
        : [];
      return snapshot;
    } finally {
      // Also abort outstanding siblings when one member of Promise.all fails.
      source.cancel("Pausenplan snapshot finished");
    }
  }
  return { load };
}
